import { InnerBox } from "@/components/elements/InnerBox";
import { YEAR_MONTH_STR_FORMAT } from "@/constants/datetime";
import { EMPTY_STR } from "@/constants/string";
import { TTalentForm } from "@/features/talent/types/talentForm";
import { divider, black } from "@/theme/colors";
import { rounded } from "@/theme/variables";
import { FCC } from "@/types/common";
import { Stack, Box, Typography, styled } from "@mui/material";
import dayjs from "dayjs";

type TTalentWorkExperienceProps = {
  defaultValues?: Partial<TTalentForm>;
};

export const TalentWorkExperience: FCC<TTalentWorkExperienceProps> = ({ defaultValues }) => {
  const workExperiences = defaultValues?.workExperiences || [];
  const hasMultipleExperiences = workExperiences.length > 1;

  return (
    <>
      <InnerBox mt={4} p={3} showDivider={false} borderColor={divider.high} bordered={true}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Box flex={1}>
            <Typography variant="head20Bold" color={black[30]}>
              職歴
            </Typography>
          </Box>
        </Stack>

        {workExperiences.length
          ? workExperiences.map((item, index) => (
              <Stack mt={3} key={index}>
                {hasMultipleExperiences && (
                  <Typography variant="sub16Bold" color={black[30]} sx={{ mb: 1 }}>
                    職歴{index + 1}
                  </Typography>
                )}
                <Stack p={2} border={`1px solid ${black[99]}`} borderRadius={rounded.sm}>
                  <Typography
                    variant="body14"
                    color={black[30]}
                    sx={{
                      mb: 0.5,
                      wordBreak: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {item.companyName ?? EMPTY_STR.TEXT}
                  </Typography>
                  <Typography
                    variant="body14"
                    color={black[30]}
                    sx={{
                      mb: 0.5,
                      wordBreak: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {item.jobType ?? EMPTY_STR.TEXT}
                  </Typography>
                  <Typography variant="cap12" color={black[70]}>
                    {item?.startDate && dayjs(item.startDate).isValid() ? dayjs(item.startDate).format(YEAR_MONTH_STR_FORMAT) : ""}
                    {item?.startDate && dayjs(item.startDate).isValid() && item?.endDate && dayjs(item.endDate).isValid() ? "～" : ""}
                    {item?.endDate && dayjs(item.endDate).isValid() ? dayjs(item.endDate).format(YEAR_MONTH_STR_FORMAT) : ""}
                  </Typography>
                </Stack>
              </Stack>
            ))
          : null}
      </InnerBox>
    </>
  );
};

export const WrappableTypography = styled(Typography)`
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
`;

export const ClampedTypography = styled(Typography)<{ lines?: number }>`
  word-break: break-word;
  overflow-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: ${({ lines = 2 }) => lines};
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const FlexWrapTypography = styled(Typography)`
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  flex: 1;
  min-width: 0;
`;
